import { render, staticRenderFns } from "./GaleriaImagemContentComponent.vue?vue&type=template&id=33f601aa&scoped=true"
import script from "./GaleriaImagemContentComponent.vue?vue&type=script&lang=js"
export * from "./GaleriaImagemContentComponent.vue?vue&type=script&lang=js"
import style0 from "./GaleriaImagemContentComponent.vue?vue&type=style&index=0&id=33f601aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f601aa",
  null
  
)

export default component.exports